export const getUserGroups = () => {
  try {
    return JSON.parse(sessionStorage.getItem('csr_user_groups') || '[]');
  } catch {
    return [];
  }
};

export const isManager = () => {
  const managerGroup = process.env.REACT_APP_CSR_MANAGER_GROUP;
  if (!managerGroup) {
    return false;
  }
  return getUserGroups().includes(managerGroup);
};

export const canDownloadEop = () => isManager();

export const canEmailEop = () => isManager();

export const canExportMessageReports = () => isManager();
